// Country core
export function countryCore() {
  const endpoint = '/countries';
  const detailId = 'countryId';

  const getDetailId = (data = null) => {
    if (!data) {
      return;
    }

    if (Array.isArray(data)) {
      return data[0][detailId];
    }

    return data[detailId];
  };

  return {
    endpoint,
    detailId,
    getDetailId: getDetailId
  };
}

// Country filter
export function countryFilter() {
  const parameter = 'CountryId';

  // Get rows
  const getRows = (data) => {
    const rows = [];

    data.forEach((row, i) => {
      // Text/numeric values
      rows[i] = {
        value: row.countryId,
        label: row.countryName,
        code: row.countryCode,
        cultures: row.cultures
      };
    });

    return rows;
  };

  return {
    parameter,
    getRows: getRows
  };
}
